import { c as _c } from "react/compiler-runtime";
import { HoverCard, Portal } from '@chakra-ui/react';
import * as React from 'react';
interface HoverCardContentProps extends HoverCard.ContentProps {
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement | null>;
}
export const HoverCardContent = React.forwardRef<HTMLDivElement, HoverCardContentProps>(function HoverCardContent(props, ref) {
  const $ = _c(11);
  let portalRef;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      portalled: t0,
      portalRef,
      ...rest
    } = props);
    $[0] = props;
    $[1] = portalRef;
    $[2] = rest;
    $[3] = t0;
  } else {
    portalRef = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const portalled = t0 === undefined ? true : t0;
  const t1 = !portalled;
  let t2;
  if ($[4] !== ref || $[5] !== rest) {
    t2 = <HoverCard.Positioner><HoverCard.Content ref={ref} {...rest} /></HoverCard.Positioner>;
    $[4] = ref;
    $[5] = rest;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== portalRef || $[8] !== t1 || $[9] !== t2) {
    t3 = <Portal container={portalRef} disabled={t1}>{t2}</Portal>;
    $[7] = portalRef;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});
export const HoverCardArrow = React.forwardRef<HTMLDivElement, HoverCard.ArrowProps>(function HoverCardArrow(props, ref) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HoverCard.ArrowTip />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props || $[2] !== ref) {
    t1 = <HoverCard.Arrow ref={ref} {...props}>{t0}</HoverCard.Arrow>;
    $[1] = props;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
});
export const HoverCardRoot = HoverCard.Root;
export const HoverCardTrigger = HoverCard.Trigger;